import Blockly from 'blockly'

class CustomCategory extends Blockly.ToolboxCategory {
  /**
   * Constructor for a custom category.
   * @override
   */
  constructor(categoryDef, toolbox, opt_parent) {
    super(categoryDef, toolbox, opt_parent)
  }
  /** @override */
  addColourBorder_(colour) {
    let labelDom = this.rowDiv_.getElementsByClassName('blocklyTreeLabel')[0]
    let iconDom = this.rowDiv_.getElementsByClassName('customIcon')[0]
    this.rowDiv_.style.backgroundColor = 'white'
    labelDom.style.color = colour
    iconDom.style.color = colour
  }
  /** @override */
  setSelected(isSelected) {
    // We do not store the label span on the category, so use getElementsByClassName.
    let labelDom = this.rowDiv_.getElementsByClassName('blocklyTreeLabel')[0]
    let iconDom = this.rowDiv_.getElementsByClassName('customIcon')[0]
    if (isSelected) {
      // Set the background back to the original colour.
      this.rowDiv_.style.backgroundColor = this.colour_
      // Set the text back to white.
      labelDom.style.color = 'white'
      iconDom.style.color = 'white'
    } else {
      // Change the background color of the div to white.
      this.rowDiv_.style.backgroundColor = 'white'
      // Set the colour of the text to the colour of the category.
      labelDom.style.color = this.colour_
      iconDom.style.color = this.colour_
    }
    // This is used for accessibility purposes.
    Blockly.utils.aria.setState(
      /** @type {!Element} */ (this.htmlDiv_),
      Blockly.utils.aria.State.SELECTED,
      isSelected
    )
  }
}

const msgKo = {
  CONTROLS_FOR_TITLE: '%1(은)는 %2부터 %3까지 %4씩 증가',
  CONTROLS_FOREACH_TITLE: '%2의 각 항목을 변수 %1에 담아 반복',
  CONTROLS_IF_MSG_THEN: '그렇다면 하기',
  CONTROLS_IF_MSG_ELSE: '아니라면 하기',
  CONTROLS_WHILEUNTIL_TITLE: '%2 %1 반복',
  CONTROLS_WHILEUNTIL_OPERATOR_WHILE: '인 동안',
  CONTROLS_WHILEUNTIL_OPERATOR_UNTIL: '까지',
  CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK: '반복 중단하기',
  CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE: '다음 반복하기',
  LOGIC_NEGATE_TITLE: '%1 이(가) 아니면 (논리값)',
  LOGIC_TERNARY_CONDITION: '',
  LOGIC_TERNARY_IF_TRUE: '가 참이라면',
  LOGIC_TERNARY_IF_FALSE: ' 거짓이라면',
  MATH_IS_TITLE: '가',
  MATH_IS_EVEN: '가 짝수(even) 이면 (논리값)',
  MATH_IS_ODD: '가 홀수(odd) 이면 (논리값)',
  MATH_IS_PRIME: '가 소수(prime) 이면 (논리값)',
  MATH_IS_WHOLE: '가 정수이면 (논리값)',
  MATH_IS_POSITIVE: '가 양(+)수 이면 (논리값)',
  MATH_IS_NEGATIVE: '가 음(-)수 이면 (논리값)',
  MATH_IS_DIVISIBLE_BY: '로 나누어 떨어지면 (논리값)',
  MATH_ON_LIST_TITLE: '%1 의 %2',
  MATH_ONLIST_OPERATOR_MODE: '가장 많이 있는 값',
  MATH_ONLIST_OPERATOR_RANDOM: '임의 항목',
  LISTS_CREATE_EMPTY_TITLE: '빈 목록',
  LISTS_CREATE_WITH_INPUT_WITH: '목록',
  LISTS_REPEAT_TITLE: '%1 을(를) %2번 넣은 목록',
  LISTS_ISEMPTY_TITLE: '%1 이(가)  빈 목록이면 (논리값)',
  LISTS_INDEX_OF_INPUT_IN_LIST: '',
  LISTS_INDEX_OF_IN: '에서',
  LISTS_INDEX_OF_ITEM: '항목이',
  LISTS_GET_INDEX_INPUT_IN_LIST: '',
  LISTS_GET_INDEX_FROM_START: '번째',
  LISTS_GET_INDEX_FROM_END: '뒤에서 # 번째',
  LISTS_GET_INDEX_RANDOM: '임의',
  LISTS_GET_INDEX_GET: '값',
  LISTS_GET_INDEX_GET_REMOVE: '잘라내기',
  LISTS_GET_INDEX_REMOVE: '삭제하기',
  LISTS_INDEX_OF_FROM: '에서',
  LISTS_INDEX_OF_TITLE_ITEM: '항목',
  LISTS_SET_INDEX_INPUT_IN_LIST: '',
  LISTS_SET_INDEX_SET: '(으)로 설정하기',
  LISTS_SET_INDEX_INSERT: '을(를) 삽입하기',
  LISTS_SET_INDEX_INPUT_TO: '항목에',
  LISTS_SET_INDEX_FROM: '의',
  TEXT_PRINT_TITLE: '%1 을(를) 출력하기',
  TEXT_JOIN_TITLE_CREATEWITH: '결합한 문장',
  TEXT_LENGTH_TITLE: '%1 의 글자수',
  TEXT_ISEMPTY_TITLE: '%1 이(가) 빈 문자열이면 (논리값)',
  TEXT_INDEXOF_TITLE: '%1 에서 %2 %3',
  TEXT_INDEXOF_OPERATOR_FIRST: '이(가) 처음으로 나타난 위치',
  TEXT_INDEXOF_OPERATOR_LAST: '이(가) 마지막으로 나타난 위치',
  TEXT_CHARAT_FROM: '에서',
  TEXT_CHARAT_TITLE: '%1 %2',
  TEXT_CHARAT_FROM_START: '번째 위치의 글자',
  TEXT_CHARAT_FROM_END: '뒤에서 # 번째 위치의 글자',
  TEXT_CHARAT_FIRST: '첫 번째 글자',
  TEXT_CHARAT_LAST: '마지막 글자',
  TEXT_CHARAT_RANDOM: '랜덤하게 한 글자',
  TEXT_GET_SUBSTRING_FROM: '에서',
  TEXT_GET_SUBSTRING_INPUT_IN_TEXT: '',
  TEXT_GET_SUBSTRING_START_FROM_START: '번째 글자부터',
  TEXT_GET_SUBSTRING_START_FROM_END: '뒤에서 # 번째 글자부터',
  TEXT_GET_SUBSTRING_START_FIRST: '처음 글자부터',
  TEXT_GET_SUBSTRING_END_FROM_START: '번째 글자까지',
  TEXT_GET_SUBSTRING_END_FROM_END: '뒤에서 # 번째 글자까지',
  TEXT_GET_SUBSTRING_END_LAST: '마지막 글자까지',
  TEXT_COUNT_MESSAGE0: '%2에서 %1 갯수 세기',
  TEXT_REPLACE_MESSAGE0: '%3에서 %2을(를) %1(으)로 바꾸기',
  VARIABLES_SET: '%1를 %2로 설정하기'
}

const moveFeildInputToLast = (_this, fieldName) => {
  let indexMode = -1
  for (let i = 0, input; (input = _this.inputList[i]); i++) {
    if (input == _this.getField(fieldName).getParentInput()) indexMode = i
  }
  if (indexMode >= 0) {
    let input = _this.inputList[indexMode]
    _this.inputList.splice(indexMode, 1)
    _this.inputList.push(input)
  }
}

const moveInputToLast = (_this, inputName) => {
  let indexMode = -1
  for (let i = 0, input; (input = _this.inputList[i]); i++) {
    if (input == _this.getInput(inputName)) indexMode = i
  }
  if (indexMode >= 0) {
    let input = _this.inputList[indexMode]
    _this.inputList.splice(indexMode, 1)
    _this.inputList.push(input)
  }
}

const moveFieldInputBefore = (_this, fromInput, toInput) => {
  let fromIndex = -1
  let toIndex = -1
  for (let i = 0, input; (input = _this.inputList[i]); i++) {
    if (input == fromInput) fromIndex = i
    if (input == toInput) toIndex = i
  }
  if (fromIndex >= 0 && toIndex >= 0)
    _this.moveNumberedInputBefore(fromIndex, toIndex)
}

const initKo = () => {
  _.forEach(_.keys(msgKo), (key) => {
    Blockly.Msg[key] = msgKo[key]
  })

  Blockly.Blocks['lists_indexOf'] = {
    init: function () {
      let OPERATORS = [
        [Blockly.Msg['LISTS_INDEX_OF_FIRST'], 'FIRST'],
        [Blockly.Msg['LISTS_INDEX_OF_LAST'], 'LAST']
      ]
      this.setHelpUrl(Blockly.Msg['LISTS_INDEX_OF_HELPURL'])
      this.setStyle('list_blocks')
      this.setOutput(true, 'Number')
      this.appendValueInput('VALUE')
        .setCheck('Array')
        .appendField(Blockly.Msg['LISTS_INDEX_OF_INPUT_IN_LIST'])
      this.appendValueInput('FIND').appendField(
        Blockly.Msg['LISTS_INDEX_OF_IN']
      )
      this.appendDummyInput()
        .appendField(Blockly.Msg['LISTS_INDEX_OF_ITEM'])
        .appendField(new Blockly.FieldDropdown(OPERATORS), 'END')
      this.setInputsInline(true)
      // Assign 'this' to a variable for use in the tooltip closure below.
      let thisBlock = this
      this.setTooltip(function () {
        return Blockly.Msg['LISTS_INDEX_OF_TOOLTIP'].replace(
          '%1',
          thisBlock.workspace.options.oneBasedIndex ? '0' : '-1'
        )
      })
    }
  }

  Blockly.Blocks['lists_getIndex'].updateAt_ = function (isAt) {
    // Destroy old 'AT' and 'ORDINAL' inputs.
    this.removeInput('AT')
    this.removeInput('ORDINAL', true)
    if (this.getInput('WHERE')) this.removeInput('WHERE')
    // Create either a value 'AT' input or a dummy input.
    if (isAt) {
      if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
        this.appendDummyInput('ORDINAL').appendField(
          Blockly.Msg['ORDINAL_NUMBER_SUFFIX']
        )
      }
      this.appendValueInput('AT').setCheck('Number')
    } else {
      this.appendDummyInput('AT')
    }
    let menu = new Blockly.FieldDropdown(this.WHERE_OPTIONS, function (value) {
      let newAt = value == 'FROM_START' || value == 'FROM_END'
      // The 'isAt' variable is available due to this function being a closure.
      if (newAt != isAt) {
        let block = this.getSourceBlock()
        block.updateAt_(newAt)
        // This menu has been destroyed and replaced.  Update the replacement.
        block.setFieldValue(value, 'WHERE')
        return null
      }
      return undefined
    })
    this.appendDummyInput('WHERE')
      .appendField(menu, 'WHERE')
      .appendField(Blockly.Msg['LISTS_INDEX_OF_TITLE_ITEM'])
    this.getInput('AT').appendField(Blockly.Msg['LISTS_INDEX_OF_FROM'])
    if (Blockly.Msg['LISTS_GET_INDEX_TAIL']) {
      this.moveInputBefore('TAIL', null)
    }

    moveFeildInputToLast(this, 'MODE')
  }

  Blockly.Blocks['lists_setIndex'].updateAt_ = function (isAt) {
    // Destroy old 'AT' and 'ORDINAL' input.
    this.removeInput('AT')
    this.removeInput('ORDINAL', true)
    if (this.getInput('WHERE')) this.removeInput('WHERE')
    // Create either a value 'AT' input or a dummy input.
    if (isAt) {
      this.appendValueInput('AT').setCheck('Number')
      if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
        this.appendDummyInput('ORDINAL').appendField(
          Blockly.Msg['ORDINAL_NUMBER_SUFFIX']
        )
      }
    } else {
      this.appendDummyInput('AT')
    }
    let menu = new Blockly.FieldDropdown(this.WHERE_OPTIONS, function (value) {
      let newAt = value == 'FROM_START' || value == 'FROM_END'
      // The 'isAt' variable is available due to this function being a closure.
      if (newAt != isAt) {
        let block = this.getSourceBlock()
        block.updateAt_(newAt)
        // This menu has been destroyed and replaced.  Update the replacement.
        block.setFieldValue(value, 'WHERE')
        return null
      }
      return undefined
    })

    this.appendDummyInput('WHERE').appendField(menu, 'WHERE')
    this.getInput('AT').appendField(Blockly.Msg['LISTS_SET_INDEX_FROM'])

    this.moveInputBefore('AT', 'TO')
    if (this.getInput('ORDINAL')) {
      this.moveInputBefore('ORDINAL', 'TO')
    }
    this.moveInputBefore('WHERE', 'TO')

    moveFeildInputToLast(this, 'MODE')
  }

  Blockly.Blocks['text_print'] = {
    /**
     * Block for print statement.
     * @this {Blockly.Block}
     */
    init: function () {
      this.jsonInit({
        message0: Blockly.Msg['TEXT_PRINT_TITLE'],
        args0: [
          {
            type: 'input_value',
            name: 'TEXT'
          }
        ],
        inputsInline: true,
        previousStatement: null,
        nextStatement: null,
        style: 'text_blocks',
        tooltip: Blockly.Msg['TEXT_PRINT_TOOLTIP'],
        helpUrl: Blockly.Msg['TEXT_PRINT_HELPURL']
      })
    }
  }

  Blockly.Constants.Text.TEXT_CHARAT_MUTATOR_MIXIN.updateAt_ = function (isAt) {
    // Destroy old 'AT' and 'ORDINAL' inputs.
    this.removeInput('AT', true)
    this.removeInput('ORDINAL', true)
    if (this.getInput('FROM')) this.removeInput('FROM')
    // Create either a value 'AT' input or a dummy input.
    this.appendDummyInput('FROM').appendField(Blockly.Msg['TEXT_CHARAT_FROM'])

    if (isAt) {
      this.appendValueInput('AT').setCheck('Number')
      if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
        this.appendDummyInput('ORDINAL').appendField(
          Blockly.Msg['ORDINAL_NUMBER_SUFFIX']
        )
      }
    }
    if (Blockly.Msg['TEXT_CHARAT_TAIL']) {
      this.removeInput('TAIL', true)
      this.appendDummyInput('TAIL').appendField(Blockly.Msg['TEXT_CHARAT_TAIL'])
    }

    this.isAt_ = isAt

    moveFeildInputToLast(this, 'WHERE')
  }

  Blockly.Blocks['text_getSubstring'].updateAt_ = function (n, isAt) {
    // Create or delete an input for the numeric index.
    // Destroy old 'AT' and 'ORDINAL' inputs.
    this.removeInput('AT' + n)
    this.removeInput('ORDINAL' + n, true)
    if (this.getInput('WHERE' + n)) this.removeInput('WHERE' + n)
    // Create either a value 'AT' input or a dummy input.
    if (isAt) {
      this.appendValueInput('AT' + n).setCheck('Number')
      if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
        this.appendDummyInput('ORDINAL' + n).appendField(
          Blockly.Msg['ORDINAL_NUMBER_SUFFIX']
        )
      }
    } else {
      this.appendDummyInput('AT' + n)
    }

    // Move tail, if present, to end of block.
    if (n == 2 && Blockly.Msg['TEXT_GET_SUBSTRING_TAIL']) {
      this.removeInput('TAIL', true)
      this.appendDummyInput('TAIL').appendField(
        Blockly.Msg['TEXT_GET_SUBSTRING_TAIL']
      )
    }
    let menu = new Blockly.FieldDropdown(this['WHERE_OPTIONS_' + n], function (
      value
    ) {
      let newAt = value == 'FROM_START' || value == 'FROM_END'
      // The 'isAt' variable is available due to this function being a
      // closure.
      if (newAt != isAt) {
        let block = this.getSourceBlock()
        block.updateAt_(n, newAt)
        // This menu has been destroyed and replaced.
        // Update the replacement.
        block.setFieldValue(value, 'WHERE' + n)
        return null
      }
      return undefined
    })

    this.appendDummyInput('WHERE' + n).appendField(menu, 'WHERE' + n)

    if (n == 1) {
      this.getInput('AT1').appendField(Blockly.Msg['TEXT_GET_SUBSTRING_FROM'])
      this.moveInputBefore('AT1', 'AT2')
      this.moveInputBefore('WHERE1', 'AT2')
    }
  }

  Blockly.Constants.Math.IS_DIVISIBLEBY_MUTATOR_MIXIN.updateShape_ = function (
    divisorInput
  ) {
    // Add or remove a Value Input.
    let inputExists = this.getInput('DIVISOR')
    if (divisorInput) {
      if (!inputExists) {
        this.appendValueInput('DIVISOR')
          .setCheck('Number')
          .appendField(Blockly.Msg['MATH_IS_TITLE'])
        moveFieldInputBefore(
          this,
          this.getInput('DIVISOR'),
          this.getField('PROPERTY').getParentInput()
        )
      }
    } else if (inputExists) {
      this.removeInput('DIVISOR')
    }
  }
}

const initAll = () => {
  Blockly.Blocks['lists_create_with'].init = function () {
    this.setHelpUrl(Blockly.Msg['LISTS_CREATE_WITH_HELPURL'])
    this.setStyle('list_blocks')
    this.itemCount_ = 3
    this.updateShape_()
    this.setInputsInline(true)
    this.setOutput(true, 'Array')
    this.setMutator(new Blockly.Mutator(['lists_create_with_item']))
    this.setTooltip(Blockly.Msg['LISTS_CREATE_WITH_TOOLTIP'])
  }
  Blockly.Blocks['lists_create_with'].updateShape_ = function () {
    if (this.itemCount_ && this.getInput('EMPTY')) {
      this.removeInput('EMPTY')
    } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
      this.appendDummyInput('EMPTY').appendField(
        Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']
      )
    }
    let i = 0
    // Add new inputs.
    for (i = 0; i < this.itemCount_; i++) {
      if (!this.getInput('ADD' + i)) {
        let input = this.appendValueInput('ADD' + i).setAlign(
          Blockly.ALIGN_RIGHT
        )
        if (i == 0) {
          input.appendField(Blockly.Msg['LISTS_CREATE_WITH_INPUT_WITH'] + ' [')
        } else if (i < this.itemCount_) {
          input.appendField(',')
        }
      }
    }
    // Remove deleted inputs.
    while (this.getInput('ADD' + i)) {
      this.removeInput('ADD' + i)
      i++
    }
    if (!this.getInput('TAIL')) {
      this.appendDummyInput('TAIL').appendField(' ]')
    }
    moveInputToLast(this, 'TAIL')
  }

  Blockly.Constants.Text.TEXT_JOIN_MUTATOR_MIXIN.updateShape_ = function () {
    if (this.itemCount_ && this.getInput('EMPTY')) {
      this.removeInput('EMPTY')
    } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
      this.appendDummyInput('EMPTY')
        .appendField(this.newQuote_(true))
        .appendField(this.newQuote_(false))
    }
    let i = 0
    // Add new inputs.
    for (i = 0; i < this.itemCount_; i++) {
      if (!this.getInput('ADD' + i)) {
        let input = this.appendValueInput('ADD' + i).setAlign(
          Blockly.ALIGN_RIGHT
        )
        if (i == 0) {
          input.appendField(Blockly.Msg['TEXT_JOIN_TITLE_CREATEWITH'])
        } else if (i < this.itemCount_) {
          input.appendField('+')
        }
      }
    }
    // Remove deleted inputs.
    while (this.getInput('ADD' + i)) {
      this.removeInput('ADD' + i)
      i++
    }
  }
}

const init = (language) => {
  if (language === 'ko') {
    initKo()
  } else {
    Blockly.Msg.CONTROLS_WHILEUNTIL_TITLE = '%1 %2'
    Blockly.Msg.MATH_ON_LIST_TITLE = '%2 %1'
  }
  initAll()

  Blockly.registry.register(
    Blockly.registry.Type.TOOLBOX_ITEM,
    Blockly.ToolboxCategory.registrationName,
    CustomCategory,
    true
  )
}

export default {
  init
}
